import { useTheme, ThemeProvider as MuiThemeProvider, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { customTheme, darkTheme } from "../../themes/themes";
import CustomThemeContext from "./ThemeContext";

const DARK_MODE_KEY = "darkMode";

export function CustomThemeContextProvider() {
  const outerTheme = useTheme();

  // Initialize from localStorage, default to false (light mode)
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const stored = localStorage.getItem(DARK_MODE_KEY);
    return stored === "true";
  });

  // Persist preference to localStorage and update root attribute
  useEffect(() => {
    localStorage.setItem(DARK_MODE_KEY, String(isDarkMode));
    document.documentElement.setAttribute("data-theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  const toggleDarkMode = useCallback(() => {
    setIsDarkMode((prev) => !prev);
  }, []);

  // Select theme based on mode
  const custom = isDarkMode ? darkTheme(outerTheme) : customTheme(outerTheme);

  return (
    <CustomThemeContext.Provider value={{ custom, isDarkMode, toggleDarkMode }}>
      <MuiThemeProvider theme={custom}>
        <CssBaseline />
        <div
          style={{
            minHeight: "100vh",
            background: isDarkMode
              ? "#1c2536"
              : "linear-gradient(135deg, #f8f8f7 0%, #f0eeeb 50%, #e8e4df 100%)",
            color: isDarkMode ? "#ffffff" : "#1a1a1a",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Outlet />
        </div>
      </MuiThemeProvider>
    </CustomThemeContext.Provider>
  );
}
